export default {
  'common': {
    'add': 'Añadir',
    'cancel': 'Cancelar',
    'description': 'Descripción',
    'delete': 'Eliminar',
    'title': 'Título',
    'save': 'Salvar',
    'faq': 'Preguntas más frecuentes',
    'contact': 'Contáctenos',
    'tos': 'Términos de servicio',
    'policy': 'Política de privacidad'
  },
  'board': {
    'titlePlaceholder': 'Ingresa un título para esta tarjeta',
    'deleteDescription': '¿Estás seguro de que deseas eliminar esta tarjeta?',
    'editCard': 'Editar tarjeta',
    'deleteCard': 'Eliminar tarjeta',
    'state': {
      'TODO': 'QUE HACER',
      'INPROGRESS': 'EN PROGRESO',
      'TESTING': 'PRUEBAS',
      'DONE': 'HECHO'
    }
  },
  'chat': {
    'online': 'Usuarios en línea ({count})',
    'addChannel': 'Agregar canal',
    'channel': 'Canal | Canales',
    'message': 'Mensaje'
  },
  'email': {
    'compose': 'Escribir correo',
    'send': 'Enviar',
    'subject': 'Tema',
    'labels': 'Etiquetas',
    'emptyList': 'Lista de correo electrónico vacía',
    'inbox': 'Bandeja de entrada',
    'sent': 'Expedido',
    'drafts': 'Borradores',
    'starred': 'Sembrado de estrellas',
    'trash': 'Basura',
    'work': 'Trabajo',
    'invoice': 'Factura'
  },
  'todo': {
    'addTask': 'Agregar tarea',
    'tasks': 'Tareas',
    'completed': 'Terminado',
    'labels': 'Etiquetas'
  },
  'dashboard': {
    'activity': 'Actividad',
    'weeklySales': 'Ventas semanales',
    'sales': 'Ventas',
    'recentOrders': 'órdenes recientes',
    'sources': 'Fuentes de tráfico',
    'lastweek': 'vs la semana pasada',
    'orders': 'Pedidos',
    'customers': 'Clientes',
    'tickets': 'Tickets de soporte',
    'viewReport': 'Vista del informe'
  },
  'usermenu': {
    'profile': 'Perfil',
    'signin': 'Registrarse',
    'dashboard': 'Tablero',
    'signout': 'Desconectar'
  },
  'error': {
    'notfound': 'Página no encontrada',
    'other': 'Ocurrió un error'
  },
  'check': {
    'title': 'Establecer nueva contraseña',
    'backtosign': 'Volver a Iniciar sesión',
    'newpassword': 'Nueva contraseña',
    'button': 'Establezca una nueva contraseña e inicie sesión',
    'error': 'El enlace de acción no es válido',
    'verifylink': 'Verificando enlace ...',
    'verifyemail': 'Verificando la dirección de correo electrónico ...',
    'emailverified': '¡Correo Electrónico Verificado! Redirigiendo ...'
  },
  'forgot': {
    'title': '¿Se te olvidó tu contraseña?',
    'subtitle': 'Ingrese la dirección de correo electrónico de su cuenta y le enviaremos un enlace para restablecer su contraseña.',
    'email': 'Email',
    'button': 'Petición para la recuperación de contraseña',
    'backtosign': 'Volver a Iniciar sesión'
  },
  'login': {
    'title': 'Registrarse',
    'email': 'Email',
    'password': 'Contraseña',
    'button': 'Registrarse',
    'orsign': 'O inicia sesión con',
    'forgot': '¿Se te olvidó tu contraseña?',
    'noaccount': '¿No tienes una cuenta?',
    'create': 'Crea uno aquí',
    'error': 'La combinación de correo electrónico / contraseña no es válida'
  },
  'register': {
    'title': 'Crear una cuenta',
    'name': 'Nombre completo',
    'email': 'Email',
    'password': 'Contraseña',
    'button': 'Crear una cuenta',
    'orsign': 'O regístrate con',
    'agree': 'Al registrarse, acepta las',
    'account': '¿Ya tienes una cuenta?',
    'signin': 'Registrarse'
  },
  'utility': {
    'maintenance': 'En mantenimiento'
  },
  'faq': {
    'call': '¿Tiene otras preguntas? Por favor comuníquese'
  },
  'ecommerce': {
    'products': 'Productos',
    'filters': 'Filtros',
    'collections': 'Colecciones',
    'priceRange': 'Rango de precios',
    'customerReviews': 'Opiniones de los usuarios',
    'up': 'y arriba',
    'brand': 'Marca',
    'search': 'Buscar producto',
    'results': 'Resultados ({0} de {1})',
    'orders': 'Pedidos',
    'shipping': 'Envío',
    'freeShipping': 'Envío gratis',
    'inStock': 'En stock',
    'quantity': 'Cantidad',
    'addToCart': 'Añadir al carrito',
    'buyNow': 'Compra ahora',
    'price': 'Precio',
    'about': 'Acerca de este artículo',
    'description': 'Descripción',
    'reviews': 'Reseñas',
    'details': 'Detalles de producto',
    'cart': 'Carro',
    'summary': 'Resumen del pedido',
    'total': 'Total',
    'discount': 'Descuento',
    'subtotal': 'Total parcial',
    'continue': 'Seguir comprando',
    'checkout': 'Revisa'
  },
  'menu': {
    'search': 'Buscar (presione \'ctrl + /\' para enfocar)',
    'dashboard': 'Tablero',
    'logout': 'Cerrar sesión',
    'profile': 'Perfil',
    'blank': 'Página en blanco',
    'pages': 'Páginas',
    'others': 'Otros',
    'email': 'Email',
    'chat': 'Charla',
    'todo': 'Que hacer',
    'board': 'Tablero de tareas',
    'users': 'Usuarios',
    'usersList': 'Lista',
    'usersEdit': 'Editar',
    'ecommerce': 'Comercio electrónico',
    'ecommerceList': 'Productos',
    'ecommerceProductDetails': 'Detalles de producto',
    'ecommerceOrders': 'Pedidos',
    'ecommerceCart': 'Carro',
    'auth': 'Páginas de autenticación',
    'authLogin': 'Iniciar sesión / Iniciar sesión',
    'authRegister': 'Registrarse / Registrarse',
    'authVerify': 'Verificar correo electrónico',
    'authForgot': 'Se te olvidó tu contraseña',
    'authReset': 'Restablecer la contraseña',
    'errorPages': 'Páginas de error',
    'errorNotFound': 'No encontrado / 404',
    'errorUnexpected': 'Inesperado / 500',
    'utilityPages': 'Páginas de utilidades',
    'utilityMaintenance': 'Mantenimiento',
    'utilitySoon': 'Próximamente',
    'utilityHelp': 'Preguntas frecuentes / Ayuda',
    'levels': 'Niveles de menú',
    'disabled': 'Menú deshabilitado',
    'docs': 'Documentación',
    'feedback': 'Retroalimentación',
    'support': 'Apoyo',
    'landingPage': 'Página de destino',
    'sms': 'SMS',
    'ivr': 'IVR',
    'pricingPage': 'Página de precios'
  },
  '$vuetify': {
    'badge': 'Insignia',
    'close': 'Cerca',
    'dataIterator': {
      'noResultsText': 'No se encontraron registros coincidentes',
      'loadingText': 'Cargando elementos ...'
    },
    'dataTable': {
      'itemsPerPageText': 'Filas por página:',
      'ariaLabel': {
        'sortDescending': 'Ordenados descendente.',
        'sortAscending': 'Ordenado ascendente.',
        'sortNone': 'Sin clasificar.',
        'activateNone': 'Activar para eliminar la clasificación.',
        'activateDescending': 'Activar para ordenar de forma descendente.',
        'activateAscending': 'Activar para ordenar de forma ascendente.'
      },
      'sortBy': 'Ordenar por'
    },
    'dataFooter': {
      'itemsPerPageText': 'Artículos por página:',
      'itemsPerPageAll': 'Todas',
      'nextPage': 'Siguiente página',
      'prevPage': 'Pagina anterior',
      'firstPage': 'Primera página',
      'lastPage': 'Última página',
      'pageText': '{0} - {1} de {2}'
    },
    'datePicker': {
      'itemsSelected': '{0} seleccionado',
      'nextMonthAriaLabel': 'Próximo mes',
      'nextYearAriaLabel': 'El próximo año',
      'prevMonthAriaLabel': 'Mes anterior',
      'prevYearAriaLabel': 'Año anterior'
    },
    'noDataText': 'Datos no disponibles',
    'carousel': {
      'prev': 'Visual anterior',
      'next': 'Siguiente visual',
      'ariaLabel': {
        'delimiter': 'Diapositiva de carrusel {0} de {1}'
      }
    },
    'calendar': {
      'moreEvents': '{0} más'
    },
    'fileInput': {
      'counter': '{0} archivos',
      'counterSize': '{0} archivos ({1} en total)'
    },
    'timePicker': {
      'am': 'AM',
      'pm': 'PM'
    },
    'pagination': {
      'ariaLabel': {
        'wrapper': 'Navegación de paginación',
        'next': 'Siguiente página',
        'previous': 'Pagina anterior',
        'page': 'Ir a la página {0}',
        'currentPage': 'Página actual, página {0}'
      }
    }
  }
}